/**
 * Handles clicks on suggested/popular search chips in the predictive
 * search empty state. Finds the chip's closest predictive-search-component,
 * sets its search input's value, and dispatches a real InputEvent with
 * inputType set.
 *
 * This matters because predictive-search.js's search() handler explicitly
 * ignores input events without an inputType — a plain
 * dispatchEvent(new Event('input')) would silently do nothing. This
 * mirrors what an actual keystroke produces instead.
 *
 * Uses event delegation on document rather than binding to each chip
 * directly, because the empty-state markup gets replaced via morph()
 * whenever search is reset — direct listeners would be lost each time.
 */
document.addEventListener('click', (event) => {
  const chip = event.target.closest('[data-suggested-search]');
  if (!chip) return;

  const component = chip.closest('predictive-search-component');
  const input = component?.querySelector('.search-input');
  if (!input) return;

  input.value = chip.dataset.suggestedSearch;
  input.dispatchEvent(new InputEvent('input', { inputType: 'insertText', bubbles: true }));
  input.focus();
});